import React from "react";
import {
  Box,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Avatar,
  IconButton,
} from "@mui/material";
import KeyboardArrowRightIcon from "@mui/icons-material/KeyboardArrowRight";
import StatusButton from "components/StatusButton";
import { useGetReviews } from "hooks/queries/useGetReviews";

const ReviewForm = () => {
  const { reviews } = useGetReviews();
  return (
    <Box
      sx={{
        display: "flex",
        position: "relative",
        flexDirection: "column",
        justifyContent: "start",
        width: "100%",
      }}
    >
      <Typography variant="h5" sx={{ fontSize: "20px", fontWeight: 800, opacity: 0.8 }}>
        Review Form
      </Typography>
      <TableContainer>
        <Table sx={{ minWidth: 650 }} aria-label="simple table">
          <TableHead>
            <TableRow>
              <TableCell>
                <Typography variant="h6" sx={{ fontWeight: 800, opacity: 0.6, fontSize: "14px" }}>
                  NAME
                </Typography>
              </TableCell>
              <TableCell align="left">
                <Typography variant="h6" sx={{ fontWeight: 800, opacity: 0.6, fontSize: "14px" }}>
                  SUBJECT
                </Typography>
              </TableCell>
              <TableCell align="left">
                <Typography variant="h6" sx={{ fontWeight: 800, opacity: 0.6, fontSize: "14px" }}>
                  STATUS
                </Typography>
              </TableCell>
              <TableCell align="left">
                <Typography variant="h6" sx={{ fontWeight: 800, opacity: 0.6, fontSize: "14px" }}>
                  ACTION
                </Typography>
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {reviews.slice(0, 3).map((review) => (
              <TableRow
                key={review.id}
                sx={{
                  "&:last-child td, &:last-child th": { border: 0 },
                  borderBottom: "none",
                }}
              >
                <TableCell component="th" scope="row">
                  {review?.form_name}
                </TableCell>
                <TableCell align="left">
                  <Box sx={{ display: "flex", alignItems: "center" }}>
                    <Avatar src={review.user?.profile_image} sx={{ width: 26, height: 26 }} />
                    <Typography
                      variant="h6"
                      sx={{
                        fontSize: "15px",
                        color: "#146ED2",
                        opacity: 0.8,
                        fontWeight: 800,
                        ml: "6px",
                      }}
                    >
                      {`${review.user?.first_name} ${review.user?.last_name}`}
                    </Typography>
                  </Box>
                </TableCell>
                <TableCell align="left">
                  <StatusButton status={review?.status} />
                </TableCell>
                <TableCell align="left" sx={{ cursor: "pointer" }}>
                  <Box sx={{ display: "flex", alignItems: "center" }}>
                    <IconButton sx={{ borderRadius: 2.5 }}>
                      <Typography variant="h6" fontSize="15px">
                        Author
                      </Typography>
                      <KeyboardArrowRightIcon sx={{ opacity: 0.5 }} />
                    </IconButton>
                  </Box>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
      <Box position="absolute" bottom={0}>
        <Typography
          variant="h4"
          sx={{
            fontSize: "16px",
            opacity: 0.8,
            fontWeight: 800,
          }}
        >
          Overdue Forms
        </Typography>
        <Box sx={{ display: "flex" }}>
          <Typography sx={{ opacity: 0.7, fontWeight: 500 }}>1 to author</Typography>
          <Typography sx={{ marginLeft: "20px", opacity: 0.7, fontWeight: 500 }}>
            2 to sign
          </Typography>
        </Box>
      </Box>
    </Box>
  );
};

export default ReviewForm;
